import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=78cdd84a"
import script from "./FontSelector.vue?vue&type=script&lang=js"
export * from "./FontSelector.vue?vue&type=script&lang=js"
import style0 from "./FontSelector.vue?vue&type=style&index=0&id=78cdd84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports